import { render } from "./WorkspaceDetail.vue?vue&type=template&id=0ed6c1fc&scoped=true"
import script from "./WorkspaceDetail.vue?vue&type=script&lang=js"
export * from "./WorkspaceDetail.vue?vue&type=script&lang=js"

import "./WorkspaceDetail.vue?vue&type=style&index=0&id=0ed6c1fc&scoped=true&lang=scss"
import "./WorkspaceDetail.vue?vue&type=style&index=1&id=0ed6c1fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ed6c1fc"]])

export default __exports__